module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_j_albino.61c3d1ea.png";